import React from 'react';
import ExternalContactsSection from './ExternalContactsSection';
import './OnboardingWorkflow.css';

const ExternalContactsModal = ({
    isOpen,
    onClose,
    contacts,
    onAdd,
    onRemove,
    isLoading,
    t = (key, fallback) => fallback || key
}) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose} style={{ zIndex: 1100 }}>
            <div
                className="modal-content-onboarding"
                onClick={e => e.stopPropagation()}
                style={{ maxWidth: '800px', width: '90%' }}
            >
                <div className="modal-header">
                    <div className="header-title-row" style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                        <i className="fa-solid fa-address-book" style={{ color: '#568ded' }}></i>
                        <h2>{t('externalContacts.modalTitle', 'Manage External Team')}</h2>
                    </div>
                    <button className="close" onClick={onClose}>&times;</button>
                </div>

                <div className="modal-body" style={{ padding: '20px', overflowY: 'auto', maxHeight: '70vh' }}>
                    <ExternalContactsSection
                        contacts={contacts}
                        onAdd={onAdd}
                        onRemove={onRemove}
                        isLoading={isLoading}
                        t={t}
                    />
                </div>

                <div className="modal-footer">
                    <button className="btn-secondary" onClick={onClose}>{t('buttons.close', 'Close')}</button>
                </div>
            </div>
        </div>
    );
};

export default ExternalContactsModal;
